module.exports = __webpack_public_path__ + "assets/img/orders.cc92f2f7.svg";